import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M11.27 14.47a4.72 4.72 0 0 0 9.44 0V6.69a4.72 4.72 0 0 0-9.44 0v7.42z"></path><path d="M27 14.41a1.58 1.58 0 0 0-3.16 0 7.84 7.84 0 0 1-15.68 0 1.58 1.58 0 0 0-3.16 0 11 11 0 0 0 9.45 10.81v1.66h-1.59a1.55 1.55 0 1 0 0 3.09h6.28a1.55 1.55 0 1 0 0-3.09h-1.55v-1.67A11 11 0 0 0 27 14.41z"></path><path d="M11 14.47a4.83 4.83 0 0 0 5 4.67 4.85 4.85 0 0 0 5-4.67V6.69A4.85 4.85 0 0 0 16 2a4.83 4.83 0 0 0-5 4.66v7.42z"></path><path d="M27 14.41a1.58 1.58 0 0 0-3.16 0 7.84 7.84 0 0 1-15.68 0 1.58 1.58 0 0 0-3.16 0 11 11 0 0 0 9.45 10.81v1.66h-1.59a1.55 1.55 0 1 0 0 3.09h6.28a1.55 1.55 0 1 0 0-3.09h-1.55v-1.67A11 11 0 0 0 27 14.41z"></path>';
export var MicrophoneSVG = function MicrophoneSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
MicrophoneSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MicrophoneSVG);